import React, { memo, PropsWithChildren, useCallback, useState } from 'react';

import { ComponentStackContext } from '@/components/core';

export type ComponentStackProps = PropsWithChildren;

const IComponentStack = ({ children }: ComponentStackProps) => {
  const [components, setComponents] = useState<React.ReactNode[]>([children]);

  const push = useCallback((node: React.ReactNode) => {
    setComponents((components) => [...components, node]);
  }, []);

  const pop = useCallback(() => {
    setComponents((components) => {
      if (components.length > 1) {
        const nextComponents = components.slice(0, -1);
        return nextComponents;
      }
      return components;
    });
  }, [setComponents]);

  return (
    <ComponentStackContext.Provider value={{ push, pop }}>
      {components[components.length - 1]}
    </ComponentStackContext.Provider>
  );
};

export const ComponentStack = memo(IComponentStack) as typeof IComponentStack;
